//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cookies from 'js-cookie'
import { CONSENT_ANON_KEY } from '~/utils/cookieConsent'

const CONSENT_VERSION = '1'
const CONSENT_KEY = 'ibjjf_cookie_consent'
const CONSENT_COOKIE = 'ibjjf_analytics_consent'
const CONSENT_SITE = 'web-ui'

function generateUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export default {
  name: 'CookieConsentBanner',
  data() {
    return {
      visible: false,
      modalOpen: false,
      analytics: false,
      marketing: false
    }
  },
  mounted() {
    const consent = this.getConsent()
    this.visible = !consent || consent.version !== CONSENT_VERSION
  },
  methods: {
    getConsent() {
      try {
        const raw = window.localStorage.getItem(CONSENT_KEY)
        return raw ? JSON.parse(raw) : null
      } catch (e) {
        return null
      }
    },
    setAnalyticsCookie(granted) {
      if (granted) {
        Cookies.set(CONSENT_COOKIE, '1', { expires: 365, path: '/', sameSite: 'Lax' })
      } else {
        Cookies.remove(CONSENT_COOKIE, { path: '/' })
      }
    },
    // Stable per-browser pseudonym that stitches a device's consent timeline
    // together server-side. Generated once and persisted next to the consent.
    getAnonymousId() {
      try {
        let id = window.localStorage.getItem(CONSENT_ANON_KEY)
        if (!id) {
          id = generateUuid()
          window.localStorage.setItem(CONSENT_ANON_KEY, id)
        }
        return id
      } catch (e) {
        // Storage blocked: skip rather than synthesize a throwaway id that would
        // never persist and would fragment the device's audit timeline.
        return null
      }
    },
    // Fire-and-forget POST of the consent record to the core audit trail. Sent
    // through $coreApi so a logged-in athlete's user_id is stamped server-side;
    // localStorage stays the source of truth, so a failure never breaks the UX.
    postConsentRecord(consent, action) {
      const anonymousId = this.getAnonymousId()
      if (!this.$coreApi || !anonymousId) return
      this.$coreApi
        .post('/consent', {
          anonymous_id: anonymousId,
          site: CONSENT_SITE,
          policy_version: consent.version,
          consent_action: action,
          occurred_at: consent.accepted_at,
          categories: consent.categories
        })
        .catch(() => {
          /* audit POST must never break the UX */
        })
    },
    saveConsent(categories, action) {
      const consent = {
        version: CONSENT_VERSION,
        accepted_at: new Date().toISOString(),
        categories
      }
      try {
        window.localStorage.setItem(CONSENT_KEY, JSON.stringify(consent))
      } catch (e) {
        // localStorage unavailable
      }
      this.setAnalyticsCookie(!!categories.analytics)
      this.applyConsent(categories)
      this.postConsentRecord(consent, action || 'updated')
    },
    applyConsent(categories) {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          analytics_storage: categories.analytics ? 'granted' : 'denied',
          ad_storage: categories.marketing ? 'granted' : 'denied'
        })
      }
    },
    hideModal() {
      // Closing the modal without saving returns to the banner so consent is
      // never silently bypassed for the session.
      this.modalOpen = false
      this.visible = true
    },
    acceptAll() {
      this.saveConsent({ essential: true, analytics: true, marketing: true }, 'granted')
      this.visible = false
      this.modalOpen = false
    },
    rejectNonEssential() {
      this.saveConsent({ essential: true, analytics: false, marketing: false }, 'rejected')
      this.visible = false
      this.modalOpen = false
    },
    openPreferences() {
      const consent = this.getConsent()
      this.analytics = !!(consent && consent.categories && consent.categories.analytics)
      this.marketing = !!(consent && consent.categories && consent.categories.marketing)
      this.visible = false
      this.modalOpen = true
    },
    savePreferences() {
      this.saveConsent(
        {
          essential: true,
          analytics: this.analytics,
          marketing: this.marketing
        },
        'updated'
      )
      this.modalOpen = false
    }
  }
}
